import * as R from 'ramda'

import type { EmployeePreferencesSchemaFragment } from 'gql/__generated__/graphql'
import type { Project } from 'services/Store/Project/types'

export const getProject = R.path<Project | null>(['data', 'project'])
export const getProjectPassOrder = R.path<Project['passOrder'] | null>([
  'data',
  'project',
  'passOrder',
])

export const selectEmployeePreferences = R.path<EmployeePreferencesSchemaFragment | null>([
  'data',
  'project',
  'employeePreferences',
])
